export const settingsLayoutWidth = '340px';
export const settingsLayoutWidthSecondLevel = '328px';
export const settingsLayoutMaxHeight = 'calc(100vh - 81px)';

export const settingsLayoutTopPosition = '-250px';
